import { AuroraAssetGroup, AuroraAwhpEvent } from '../types'
import { Chip, ChipProps } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { isAuroraAwhpAlarmEvent } from '../utils/aurora'

export interface AuroraAssetGroupAlarmStatusChipProps extends Omit<ChipProps, 'label' | 'color'> {
  auroraAssetGroup: AuroraAssetGroup
  auroraAwhpActiveEvents: Record<string, AuroraAwhpEvent[]>
}

export default function AuroraAssetGroupAlarmStatusChip({
  auroraAssetGroup,
  auroraAwhpActiveEvents,
  ...props
}: AuroraAssetGroupAlarmStatusChipProps) {
  const { t } = useTranslation('aurora')

  const activeAlarmEvents = Array.from(
    Object.values(auroraAwhpActiveEvents).flat().filter(isAuroraAwhpAlarmEvent)
  )

  if (activeAlarmEvents.length === 0) {
    return null
  }

  return <Chip label={t('immidiateReview')} color="error" {...props} />
}
